 function findCountry(countryName, countries) {
    const foundCountry = countries
    .filter((el) => el.name.toLowerCase().includes(countryName.toLowerCase()))
    .map(el => {
        return {label: el.name, countryCode: el.code}
    });

    return foundCountry;

}


 function getCityName(cityObject) {
    const cityName = cityObject?.cityName;
    const labelShort = cityObject?.labelShort;
    const zipCode = cityObject?.zipCode;

    if(cityName) {
        return cityName;
    }


    if(zipCode && zipCode.length > 0) {
        return labelShort.split(zipCode)[0].trim()
    }

    if(!cityName) {
        return labelShort.trim();
    }

    if(zipCode && zipCode.length === 0) {
        return ''
    }
}

function getProvinceName(cityObject) {
    const cityName = cityObject?.cityName;
    const provinceCode = cityObject?.provinceCode;
    if(cityName) {
        return provinceCode;
    }

    if(!cityName && provinceCode) {
        return provinceCode;
    }

    if(!cityName && !provinceCode) {
        return '';
    }
}

function getZipCode(cityObject) {
    const cityName = cityObject?.cityName;
    const provinceCode = cityObject?.provinceCode;
    const zipCode = cityObject?.zipCode;

    if(cityName) {
        return zipCode;
    }

    if(!cityName && zipCode) {
        return zipCode;
    }

    if(!cityName && !provinceCode) {
        return '';
    }
}

function togglePropertyField({ items, fieldName, booleanValue, propertyName}) {
    const foundItem = items.find(item => item.id === fieldName);
    const foundItemIndex = items.findIndex(item => item.id === fieldName);
    foundItem[propertyName] = booleanValue;
    items[foundItemIndex] = foundItem;
}

function  resetCityProvinceZipField(items) {
    items.forEach((item => {
        if (item.id === 'city') {
            item.value = '';
        }else if (item.id === 'province') {
            item.value = '';
        }else if (item.id === 'zip') {
            item.value = '';
        }
    }));
}



export {
    findCountry,
    getCityName,
    getProvinceName,
    getZipCode,
    togglePropertyField,
    resetCityProvinceZipField
}


export function RemoveEmptyFields(object) {
    if (!object) return {};
    return Object.fromEntries(Object.entries(object).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
    );
}

export const ArlunoWarehouse = {
    Name: "Arluno",
    City: "Arluno",
    Province: "MI"
}

export const getPaginatedData = ({
    items = [],
    currentPage = 1,
    itemsPerPage = 10,
}) => {
    const safeItems = Array.isArray(items) ? items : [];
    const safeItemsPerPage = Number(itemsPerPage) > 0 ? Number(itemsPerPage) : 10;
    const totalItems = safeItems.length;
    const totalPages = Math.ceil(totalItems / safeItemsPerPage);

    const normalizedCurrentPage = totalPages > 0
        ? Math.min(Math.max(currentPage, 1), totalPages)
        : 1;
    const startIndex = (normalizedCurrentPage - 1) * safeItemsPerPage;
    const endIndex = startIndex + safeItemsPerPage;

    return {
        totalItems,
        totalPages,
        currentPage: normalizedCurrentPage,
        itemsPerPage: safeItemsPerPage,
        paginatedItems: safeItems.slice(startIndex, endIndex),
        startIndex,
        endIndex
    }

}

export const getVisiblePages = (totalPages, currentPage) => {
    if (totalPages <= 5) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 3) {
        return [1, 2, 3, 4, "dots", totalPages];
    }

    if (currentPage >= totalPages - 2) {
        return [1, "dots", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }

    return [1, "dots", currentPage - 1, currentPage, currentPage + 1, "dots", totalPages];
}

const formatter = new Intl.DateTimeFormat("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
});

export const formatDateTime = (datetime) => {
    if (!datetime) return "-";
    return formatter.format(new Date(datetime));
};

export const CreateLog = ({level = "log", message, data = null }) => {

    const levels = {
        log: console.log,
        warn: console.warn,
        error: console.error,
    };
    const logFunction = levels[level] || console.log;

    if (data) {
        logFunction(`[${level.toUpperCase()}] ${message}`, data);
    } else {
        logFunction(`[${level.toUpperCase()}] ${message}`);
    }
}

export const hasAnyPermission = (
    userPermissions,
    requiredPermissions
) => {
    const safeUserPermissions = Array.isArray(userPermissions)
        ? userPermissions
        : [];

    const safeRequiredPermissions =
        Array.isArray(requiredPermissions)
            ? requiredPermissions
            : requiredPermissions &&
                typeof requiredPermissions === "object"
                ? Object.values(requiredPermissions)
                : [];

    return safeRequiredPermissions.some(permission =>
        safeUserPermissions.includes(permission)
    );
};

export const hasPermission = (userPermissions, permission) => {
    return Array.isArray(userPermissions)
        && userPermissions.includes(permission);
}

export function normalizePermissions(value) {
    if (!Array.isArray(value)) {
        return [];
    }

    return [...new Set(
        value
            .filter(permission => typeof permission === "string")
            .map(permission => permission.trim())
            .filter(permission => permission.length > 0)
    )];
}